export enum BotStatusEnum {
  READY = 'READY',
  RUNNING = 'RUNNING',
  FINISHED = 'FINISHED',
  STOP = 'STOP',
  ERROR = 'ERROR',
}
